import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useEffectiveRole } from '@/features/impersonation/useImpersonation';

export const ROLE_HOME: Record<string, string> = {
  technician: '/tech',
  manager: '/manager',
  admin: '/admin',
  leadership: '/leadership',
  // Stored role of a view-only login; only seen as an act-as target's role.
  viewer: '/manager',
};

export function RoleRedirect() {
  const { user, isLoading } = useAuth();
  const effectiveRole = useEffectiveRole();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-fw-text-muted text-sm">Loading…</div>
      </div>
    );
  }

  // Anon users land on the tech roster tablet view by default — that's the
  // primary path for 8 of 10 Airoldi users. Managers / admins / leadership
  // have a "Staff sign-in" affordance from there.
  if (!user) return <Navigate to="/select-tech" replace />;
  const path = (effectiveRole && ROLE_HOME[effectiveRole]) ?? '/select-tech';
  return <Navigate to={path} replace />;
}
